<template>
  <div class="pages">
    <pages-header @search="handleSearch"></pages-header>
    <van-index-bar :sticky-offset-top="52" :index-list="[]" highlight-color="#3D3833">
        <div v-for="(zeroItem,zeroIndex) in list" :key="'customer' + zeroIndex">
            <van-index-anchor>
                <div class="zero-name">{{ zeroItem.zeroName || "" }}</div>
            </van-index-anchor>
            <div class="list-item" v-for="twoItem in zeroItem.children" :key="'two' + twoItem.id" @click="handleCheckboxClick(twoItem.id)">
                <van-checkbox 
                    :value="twoIds.includes(twoItem.id)" 
                    icon-size="14px"
                    checked-color="#F1892E"
                    v-if="routeQuery.singleMultiple === 'multiple'"
                >{{ twoItem.concatenatedName || "" }}</van-checkbox>
                <div class="list-item__label" v-else-if="routeQuery.singleMultiple === 'single'">{{ twoItem.concatenatedName || "" }}</div>
                <van-icon name="arrow" size="14px" color="#C9C2BB" style="margin-left: 8px;" v-if="routeQuery.singleMultiple === 'single'" />
            </div>
        </div>
    </van-index-bar>
    <pages-footer :twoIds="twoIds" @cancel="handleCancel" @confirm="handleConfirm"></pages-footer>
  </div>
</template>

<script>
import pagesHeader from "./components/pages-header.vue";
import { getList } from "@/api/material/warehouseMapList/index.js";
import { IndexBar, IndexAnchor , Checkbox , Icon } from "vant";
import pagesFooter from "./components/pages-footer.vue";
export default {
    components: {
        pagesHeader,
        pagesFooter,
        [IndexBar.name]: IndexBar,
        [IndexAnchor.name]: IndexAnchor,
        [Checkbox.name]: Checkbox,
        [Icon.name]: Icon,
    },
    data(){
        return {
            queryParams: {
                state: 0,
                level: 2,
                concatenatedName: ""
            },
            list: [],
            mapList: [],
            listLoading: false,
            emptyList: false,
            twoIds: [],
            routeQuery: {
                // singleMultiple: "single"
                // singleMultiple: "multiple"
            }
        }
    },
    created(){
        this.routeQuery = this.deepClone(this.$route.query);
        console.log("warehouseMapList created routeQuery",this.deepClone(this.routeQuery))
        if(process.env.NODE_ENV === "development") window._this = this;
        this.getList();
        document.title = this.$route.query.pagesTitle;
    },
    methods: {
        handleConfirm(){
            this.$bus.emit("warehouseSelectFinish",this.deepClone({
                ...this.routeQuery,
                twoData: this.mapList.filter(item => this.twoIds.includes(item.id)),
            }));
            this.$router.back();
        },
        handleCancel(){
            this.$router.back();
        },
        handleSearch(value){
            this.queryParams.concatenatedName = value;
            this.getList();
        },
        async getList(){
            try {
                this.list = [];
                this.listLoading = true;
                this.emptyList = false;
                let { data } = await getList(this.queryParams);
                this.mapList = data ? this.deepClone(data) : [];
                this.list = data ? data.reduce((list,item) => {
                    item.concatenatedName = item.concatenatedName.replace(/\,/g," ");
                    let zeroName = item.concatenatedName.split(" ")[0];
                    let index = list.findIndex(findItem => findItem.zeroName === zeroName);
                    if(~index) {
                        let newList = this.deepClone(list);
                        newList[index].children.push(item);
                        return newList;
                    }else {
                        return [...list,{
                            zeroName,
                            children: [item]
                        }]
                    }
                },[]) : [];
                console.log("list",this.deepClone(this.list));
                this.listLoading = false;
                if(!data || !data.length) this.emptyList = true;
                return Promise.resolve(data);
            } catch (error) {
                this.listLoading = false;
                this.emptyList = true;
                return Promise.reject(error);
            }
        },
        handleCheckboxClick(id){
            let idIndex = this.twoIds.findIndex(findId => findId === id);
            if(this.routeQuery.singleMultiple === "single") {
                this.twoIds = [id];
                this.handleConfirm();
            }else if(this.routeQuery.singleMultiple === "multiple") {
                if(~idIndex) {
                    this.twoIds.splice(idIndex,1);
                }else {
                    this.twoIds.push(id);
                };
            }
        },
    }
}
</script>

<style scoped lang="scss">
    .pages {
        padding: 52px 0 54px 0;
        .list-item {
            padding: 16px 12px;
            background-color: #FFF;
            display: flex;
            align-items: center;
            .list-item__label {
                font-size: 14px;
                color: #3D3833;
                flex: 1;
                overflow: hidden;
            }
        }
    }
    ::v-deep .van-index-anchor {
        background: #F8F8F8;
        font-size: 14px;
        padding: 0 !important;
        .zero-name {
            padding: 0 12px !important;
        }
    }
    ::v-deep .van-checkbox__label {
        font-size: 16px;
    }
</style>